<template>
  <div class="console_r">
    <!-- <sub-header :id="queryParams.hennery_id" name="health"></sub-header> -->
    <div class="console_r_card">
      <div class="title">
        <b>{{currHenneryName}} - 健康指数<i @click="refresh" class="el-icon-refresh" title="刷新"></i></b>
        <!-- <span>当前记录：{{count}}</span> -->
      </div>
      <div class="con">
        <div class="con-topping">
          <div class="topping-item" v-for="(item, index) in buildingLatestHealthyIndexList" :key="index">
            <div class="item-name">{{item.name}}：</div>
            <div class="item-hi">
              <i :style="{color: item.status}" class="el-icon-s-opportunity"></i>
              <span class="hi-val">健康指数：{{item.status_val}}</span>
              <span>AI诊断：{{item.status_txt}}</span>
            </div>
          </div>
        </div>
        <div class="con-topping-des">
          <p>健康指数得分越高表示AI认为鸡群越健康，其中绿色{{this.healthThreshold[1]}}-100分为健康，黄色{{this.healthThreshold[0]}}-{{this.healthThreshold[1]}}分为疑似不健康，红色{{this.healthThreshold[0]}}分以下为不健康。</p>
          <p>每台设备的得分仅代表设备周围5-8米范围内鸡群的估算结果，而栋舍的得分为该栋舍所有设备的平均结果。</p>
        </div>
        <div class="con_top">
          <el-date-picker
            style="width: 240px"
            v-model="startTime"
            @change="(e) => dateChange(1, e)"
            type="date"
            value-format="timestamp"
            placeholder="选择开始时间">
          </el-date-picker>
          <el-date-picker
            style="width: 240px"
            v-model="endTime"
            @change="(e) => dateChange(2, e)"
            type="date"
            value-format="timestamp"
            placeholder="选择结束时间">
          </el-date-picker>
          <el-button type="primary" @click="searchTable" round>查询</el-button>
        </div>
        <div class="con-item-title">按分栋：</div>
        <el-table 
        :data="buildingDailyHealthyIndexList" 
        style="width: 100%" 
        :default-sort = "{prop: 'name'}"
        border>
          <el-table-column prop="name" label="分栋名称" sortable></el-table-column>
          <el-table-column v-for="(item, index) in tableDateList" :key="index" :label="item">
            <template slot-scope="scope">
              <i :style="{color: scope.row.status_obj[index].status}" class="el-icon-s-opportunity"></i>
              <span style="margin-left: 5px">{{ scope.row.status_obj[index].status_val}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="con-item-title">按设备：</div>
        <el-table 
        :data="list" 
        style="width: 100%" 
        :default-sort = "{prop: 'building_name'}"
        border>
          <el-table-column prop="building_name" label="分栋" sortable></el-table-column>
          <el-table-column prop="device_hostname" label="设备名称" sortable></el-table-column>
          <el-table-column prop="device_custom_name" label="设备昵称" sortable></el-table-column>
          <el-table-column v-for="(item, index) in tableDateList" :key="index" :label="item">
            <template slot-scope="scope">
              <i :style="{color: scope.row.status_obj[index].status}" class="el-icon-s-opportunity"></i>
              <span style="margin-left: 5px">{{ scope.row.status_obj[index].status_val}}</span>
            </template>
          </el-table-column>
        </el-table>
        
        <div class="con_top" style="padding: 50px 0;">
          <el-date-picker
            style="width: 240px"
            v-model="startTime2"
            @change="(e) => dateChange(3, e)"
            type="date"
            value-format="timestamp"
            placeholder="选择开始时间">
          </el-date-picker>
          <el-date-picker
            style="width: 240px"
            v-model="endTime2"
            @change="(e) => dateChange(4, e)"
            type="date"
            value-format="timestamp"
            placeholder="选择结束时间">
          </el-date-picker>
          <el-button type="primary" @click="searchChart" round>查询</el-button>
        </div>
        <div class="chart">
          <div class="chart-top">
            <span class="chart-title">鸡场分析图</span>
          </div>
          <line-chart :chart-data="henneryData" />
        </div>
        <div class="chart">
          <div class="chart-top">
            <el-dropdown @command="handleCommand">
              <span class="chart-title">{{!!currBuilding ? currBuilding.name : ''}}分析图<i class="el-icon-arrow-down el-icon--right"></i></span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(item, index) in buildingList" :key="index" :command="item">{{item.name}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <line-chart :chart-data="buildingData" />
        </div>
      </div>
      <!-- <div style="text-align: center">
        <el-pagination
        style="padding: 20px 0 40px"
        background
        layout="prev, pager, next"
        @current-change="currPageChange"
        :page-size="queryParams.limit"
        :total="count">
        </el-pagination>
      </div> -->
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui';
import moment from '@/libs/moment'
import { getHealthyIndexApi, getHenneryHealthyIndexApi, getBuildingHealthyIndexApi, getBuildingListApi, getBuildingDailyHealthyIndexApi, getBuildingLatestHealthyIndexApi } from '@/api/user'
import LineChart from '@/components/charts/LineChart.vue'
import SubHeader from '@/components/SubHeader'

export default {
  name: 'Health',
  components: {
    LineChart,
    // SubHeader
  },
  data() {
    return {
      currHenneryName: '',
      currAct: 'health',
      currHenneryId: Number(this.$route.params.id),
      queryParams: {
        // skip: 0,
        // limit: 100,
        start_time: null,
        end_time: null,
        hennery_id: ''
        // id: 4
      },
      list: [],
      count: 0,
      startTime: null,
      endTime: null,
      oneDayTime: 60 * 60 * 24 * 1000,
      tableDateList: [],
      // 图表统计部分
      queryParams2: {
        start_time: null,
        end_time: null,
        hennery_id: ''
      },
      startTime2: null,
      endTime2: null,
      xData: [],
      emptyData: [],
      henneryData: {
        xData: [],
        yData: null
      },
      currDate: '',
      buildingData: {
        xData: [],
        yData: null
      },
      buildingList: [],
      currBuilding: null,
      buildingDailyHealthyIndexList: [],
      buildingLatestHealthyIndexList: [],
      healthThreshold: [80, 90], // 健康指数阈值，arr[0]以下不健康，arr[0] ~ arr[1]疑是不健康，arr[1]以上健康
    }
  },
  methods: {
    handleCommand (command) {
      if(this.currBuilding.id === command.id) return
      this.currBuilding = command
      this.getBuildingHealthyIndexData()
    },
    dateChange (type, e) {
      console.log(type, e)
      if(e) {
        // this.queryParams.start_time = moment(e).valueOf()
        // this.queryParams.end_time = this.queryParams.start_time + this.oneDayTime
        // this.getHenneryLivenessData()
        // this.getBuildingLivenessData()
        if(type === 1) {
          this.endTime = this.startTime + this.oneDayTime * 6
          this.queryParams.start_time = this.startTime
          this.queryParams.end_time = this.startTime + this.oneDayTime * 7
        } else if (type === 2) {
          this.startTime = this.endTime - this.oneDayTime * 6
          this.queryParams.start_time = this.startTime
          this.queryParams.end_time = this.endTime + this.oneDayTime
        } else if (type === 3) {
          this.queryParams2.start_time = this.startTime2
        } else if (type === 4) {
          this.queryParams2.end_time = this.endTime2 + this.oneDayTime
        }
      }
    },
    getList () {
      this.tableDateList = []
      for(let i=this.startTime; i<=this.endTime; i+=this.oneDayTime) {
        this.tableDateList.push(moment(i).format("YYYY-MM-DD"))
      }
      getHealthyIndexApi(this.queryParams).then(res=>{
        let data = res.data.data.device_indexes ? res.data.data.device_indexes : []
        this.currHenneryName = res.data.data.hennery.name
        data.forEach((item) => {
          item.name = !!item.device_custom_name ? item.device_custom_name : item.device_hostname
          item.status_obj = []
          item.healthy_index.forEach(val => {
            let obj = {}
            this.setHealthyIndexStatus(val, obj)
            item.status_obj.push(obj)
          })
        })
        this.list = data.sort((a, b) => a.name.localeCompare(b.name))
        this.loadingData = false
      }).catch(() => {
        this.loadingData = false
      })
    },
    setHealthyIndexStatus (val, item) {
      item.status_val = val !== null ? val.toFixed(2) : val
      if (val == null) {
        item.status = 'gray'
        item.status_txt = '-'
        item.status_val = '-'
      } else if(val >= this.healthThreshold[1]) {
        item.status = 'green'
        item.status_txt = '健康'
      } else if(val >= this.healthThreshold[0] && val <this.healthThreshold[1]) {
        item.status = 'orange'
        item.status_txt = '疑似不健康'
      } else if(val >= 0 && val < this.healthThreshold[0]) {
        item.status = 'red'
        item.status_txt = '不健康'
      } else {
        item.status = 'gray'
        item.status_txt = '-'
      }
    },
    lineItem (name, data) {
      return {
        name: name,
        type: 'line',
        data: data,
        connectNulls: true
      }
    },
    getHenneryHealthyIndexData () {
      this.henneryData.yData = null
      getHenneryHealthyIndexApi(this.queryParams2).then(res=>{
        let data = res.data.data
        this.henneryData.yData = []
        // if(data.hennery_healthy_index && data.hennery_healthy_index.length>0) {
        //   this.henneryData.yData.push(this.lineItem('总鸡场', data.hennery_healthy_index))
        // } else {
        //   this.henneryData.yData.push(this.lineItem('总鸡场', this.emptyData))
        // }
        if(data.building_healthy_index && data.building_healthy_index.length > 0) {
          data.building_healthy_index.forEach(bl => {
            this.henneryData.yData.push(this.lineItem(bl.name, bl.healthy_index.length>0 ? bl.healthy_index : this.emptyData))
          })
        }
        console.log(this.henneryData.yData)
      }).catch(() => {
        // this.loadingData = false
        this.henneryData.yData = []
      })
    },
    getBuildingHealthyIndexData () {
      this.buildingData.yData = null
      getBuildingHealthyIndexApi({...this.queryParams2, building_id: this.currBuilding.id}).then(res => {
        let data = res.data.data
        this.buildingData.yData = []
        // if(data.building_healthy_index.healthy_index && data.building_healthy_index.healthy_index.length>0) {
        //   this.buildingData.yData.push(this.lineItem('总栋', data.building_healthy_index.healthy_index))
        // } else {
        //   this.buildingData.yData.push(this.lineItem('总栋', this.emptyData))
        // }
        if(data.device_healthy_index && data.device_healthy_index.length>0) {
          data.device_healthy_index.forEach(dl => {
            let name = dl.device_custom_name ? dl.device_custom_name : dl.device_hostname
            this.buildingData.yData.push(this.lineItem(name, dl.healthy_index.length>0 ? dl.healthy_index : this.emptyData))
          })
        }
      }).catch(() => {
        this.buildingData.yData = []
      })
      // console.log('this.buildingData', this.buildingData)
    },
    getBuildingDailyHealthyIndexData () {
      getBuildingDailyHealthyIndexApi(this.queryParams).then(res => {
        let data = res.data.data
        this.buildingDailyHealthyIndexList = data.building_healthy_index
        data.building_healthy_index.forEach(item => {
          item.status_obj = []
          item.healthy_index.forEach(val => {
            let obj = {}
            this.setHealthyIndexStatus(val, obj)
            item.status_obj.push(obj)
          })
        })
      })
    },
    getBuildingLatestHealthyIndexData () {
      getBuildingLatestHealthyIndexApi(this.queryParams).then(res => {
        let data = res.data.data
        this.buildingLatestHealthyIndexList = data.building_healthy_index.sort((a, b) => a.name.localeCompare(b.name))
        this.buildingLatestHealthyIndexList.forEach(item => {
          let val = item.healthy_index[0]
          this.setHealthyIndexStatus(val, item)
        })
      })
    },
    getBuildingList () {
      getBuildingListApi({
        skip: 0,
        limit: 100,
        hennery_id: this.queryParams.hennery_id
      }).then(res=>{
        let data = res.data.data.buildings
        if(!data || data.length <= 0) {
          return
        }
        this.buildingList = data.sort((a, b) => a.name.localeCompare(b.name))
        if(!this.currBuilding) this.currBuilding = this.buildingList[0]
        // if(!this.currBuildingId) {
        //   this.currBuildingId = this.buildingList[0].id
        //   this.currBuildingName = this.buildingList[0].name
        // }
        this.getBuildingHealthyIndexData()
      })
    },
    refresh () {
      this.getList()
      this.getHenneryHealthyIndexData()
      this.getBuildingList()
      this.getBuildingDailyHealthyIndexData()
      this.getBuildingLatestHealthyIndexData()
    },
    searchTable () {
      this.getList()
      this.getBuildingDailyHealthyIndexData()
    },
    searchChart () {
      if(this.queryParams2.end_time - this.queryParams2.start_time > this.oneDayTime * 31) {
        Message.error('时间范围不可超过31天')
        return
      }
      this.getXData()
      this.getHenneryHealthyIndexData()
      this.getBuildingHealthyIndexData()
    },
    getXData () {
      this.xData = []
      for(let i=this.queryParams2.start_time; i<this.queryParams2.end_time; i+=60*60*1000) {
        this.xData.push(moment(i).format('YYYY-MM-DD HH:mm'))
        this.emptyData.push(0)
      }
      this.henneryData.xData = this.xData
      this.buildingData.xData = this.xData
    },
  },
  watch: {
  },
  created(){
    this.$store.commit('setCurrHenneryId', this.$route.params.id)
    let now = moment().format('YYYY-MM-DD')
    this.endTime = moment(`${now} 00:00:00`).valueOf()
    this.dateChange(2, this.endTime)
    this.queryParams.hennery_id = this.currHenneryId
    this.queryParams2.hennery_id = this.currHenneryId
    this.queryParams2.start_time = this.endTime
    this.queryParams2.end_time = this.queryParams2.start_time + this.oneDayTime
    this.startTime2 = this.endTime
    this.endTime2 = this.endTime
    this.refresh()
    this.getXData()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import 'poultry.scss';
.con-item-title {
  font-size: 18px;
  color: #aab6e4;
  padding: 20px 0;
}
.con-topping {
  width: 650px;
  margin: 0 auto;
  padding-top: 80px;
  color: #aab6e4;
  .topping-item {
    display: flex;
    align-items: center;
    .item-name {
      width: 140px;
      font-size: 26px;
      font-weight: bold;
      margin-right: 10px;
      text-align: right;
    }
    .item-hi {
      font-size: 26px;
      .hi-val {
        width: 215px; 
        display: inline-block;
        margin-right: 20px;
        margin-left: 5px;
      }
    }
  }
}
.con-topping-des {
  color: #6b7dc6;
  padding: 20px 0 80px;
  line-height: 18px;
  font-size: 14px;
  text-align: center;
  p {
    padding: 3px 0;
  }
}
.chart {
  padding-bottom: 20px;
  .chart-top {
    display: flex;
    justify-content: center;
    .chart-title {
      cursor: pointer;
      color: #6ab8ff;
      font-weight: bold;
      font-size: 18px;
    }
  }
}
.switch-day {
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  text-align: center;
  padding: 20px 0;
}
.bar-mark {
  display: flex;
  justify-content: center;
  align-items: center;
  .bar-mark-item {
    display: flex;
    // justify-content: center;
    align-items: center;
    padding: 0 15px;
    .bar-mark-color {
      width: 30px;
      height: 15px;
      margin-right: 2px;
    }
    .bar-mark-name {
      color: #aab6e4;
    }
  }
}
.time-scroll {
  overflow: auto;
  .time-axis {
    // display: flex;
    white-space: nowrap;
    padding: 100px 50px;
    .time-axis-item {
      display: inline-block;
      .item-bar {
        width: 5px;
        height: 30px;
        background-color: gray;
        position: relative;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
        .item-scale {
          width: 100px;
          text-align: center;
          position: absolute;
          right: -45px;
          top: 30px;
          // background-color: blue;
          &::after {
            content: '';
            display: inline-block;
            width: 1px;
            height: 5px;
            background-color: #ffffff;
            position: absolute;
            left: 50px;
            top: 0;
          }
        }
      }
    }
  }
}
</style>
